module.exports = __webpack_public_path__ + "media/images/icons/assessment-76ccbc11ddfe4184f35f09066742af20.png";